/*
 * Fallconi home: swipeable image carousel for each product card in the grid.
 */
(() => {
  const initGallery = (gallery) => {
    if (gallery.dataset.fallconiHomeReady === 'true') return;
    gallery.dataset.fallconiHomeReady = 'true';

    const track = gallery.querySelector('[data-home-gallery-track]');
    const prev = gallery.querySelector('[data-home-gallery-prev]');
    const next = gallery.querySelector('[data-home-gallery-next]');
    if (!track || !prev || !next) return;

    const updateArrows = () => {
      const { scrollLeft } = track;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= maxScroll - 1;

      [
        [prev, atStart],
        [next, atEnd],
      ].forEach(([button, disabled]) => {
        button.classList.toggle('is-disabled', disabled);
        button.disabled = disabled;
      });
    };

    /* Nav clicks must not follow the card's link to the product page. */
    const go = (event, delta) => {
      event.preventDefault();
      event.stopPropagation();
      track.scrollBy({ left: delta, behavior: 'smooth' });
    };

    prev.addEventListener('click', (event) => go(event, -track.clientWidth));
    next.addEventListener('click', (event) => go(event, track.clientWidth));

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  };

  const closeQuickBuy = (card) => {
    const panel = card.querySelector('[data-home-quickbuy]');
    const toggle = card.querySelector('[data-home-cart-toggle]');
    if (!panel) return;
    panel.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  };

  const initQuickBuy = (card) => {
    if (card.dataset.fallconiHomeQuickbuyReady === 'true') return;
    card.dataset.fallconiHomeQuickbuyReady = 'true';

    const toggle = card.querySelector('[data-home-cart-toggle]');
    const panel = card.querySelector('[data-home-quickbuy]');
    if (!toggle || !panel) return;

    const variantInput = panel.querySelector('[data-home-variant-input]');
    const variantButtons = Array.from(panel.querySelectorAll('[data-variant-id]'));

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = !panel.hidden;
      document.querySelectorAll('[data-home-card]').forEach(closeQuickBuy);
      if (!isOpen) {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    panel.addEventListener('click', (event) => event.stopPropagation());

    variantButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        if (button.disabled) return;

        variantButtons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        if (variantInput) variantInput.value = button.dataset.variantId;
      });
    });
  };

  const initAll = (scope) => {
    (scope || document).querySelectorAll('[data-home-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-home-card]').forEach(initQuickBuy);
  };

  document.addEventListener('click', () => {
    document.querySelectorAll('[data-home-card]').forEach(closeQuickBuy);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-home-card]').forEach(closeQuickBuy);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
